module.exports = __webpack_public_path__ + "img/logo-h.dbd011a2.png";